// extracted by mini-css-extract-plugin
export default {"container":"js-z","heading":"ks-z","text":"ls-z","info":"ms-z","link":"ns-z","fullMaxWidth":"os-z"};